export default {
  title: 'Summary',
  export: 'Export as CSV',
  filters: {
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    searchPlaceholder: 'Job request name',
    statusFilterLabel: 'Status'
  },
  loadingError: 'Sorry, something went wrong. Please try again.',
  exportError: 'Failed to generate export. Please try again later.',
  pendingExport: 'Processing. You will receive email with report soon',
  exportModalTitle: 'Large Summary Report export',
  exportModalText: "We'll email you a link to the report when it's ready",
  expandAllRows: 'Expand rows',
  collapseAllRows: 'Collapse rows',
  table: {
    venue: 'Location',
    venueAddress: 'Address',
    cityAndState: 'City & State',
    startDate: 'Start Date',
    startTime: 'Start Time',
    requestName: 'Job Name',
    jobRequestId: 'Job Request ID',
    jobRequestCode: 'Job Code',
    jobRequestStatus: 'Status',
    hourlyRate: 'Hourly Pay Rate',
    flatRate: 'Flat Rate',
    scheduledHours: 'Scheduled Hours',
    scheduledPay: 'Scheduled Pay',
    slotsPosted: 'Slots Posted',
    slotsFilled: 'Slots Filled',
    jobsStarted: 'Jobs Started',
    jobsCompleted: 'Jobs Completed',
    slotsCancelled: 'Slots Cancelled',
    absent: 'Absent',
    sumHoursWorked: 'Hours Worked',
    coveredCosts: 'Covered Costs',
    sumWonoloerPay: 'Wonoloer Pay',
    sumTotalCost: 'Total Cost',
    expectedVsNeed: 'Filled/ Posted',
    actualVsNeed: 'Started/ Filled',
    actualVsExpected: 'Completed/ Started',
    completedVsPosted: 'Completed/ Posted',
    noResults: 'No results found',
    noResultsSubtext: 'Try different keywords or expanding your date range'
  }
};
